import * as React from 'react';
import { IConditionalTabItemContentProps } from '../conditional-tab-item/conditional-tab-item';
import { IProductInfoContentData } from './product-info-content.data';
import { IProductInfoContentProps } from './product-info-content.props.autogenerated';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import InnerHTML from 'dangerously-set-html-content';

export interface IProductInfoContentViewProps extends IProductInfoContentProps<IProductInfoContentData> {
    Container: IModuleProps;
    content: React.ReactNode;
}

type ProductInfoContentExtentedProps = IProductInfoContentProps<IProductInfoContentData> & IConditionalTabItemContentProps;

const ProductInfoContent = (props: ProductInfoContentExtentedProps) => {
    const {
        config,
        data: {
            productInfo: { result: productInfo }
        },
        onVisibilityChange
    } = props;

    const hasData = !!productInfo?.WebText;
    React.useEffect(() => {
        onVisibilityChange && onVisibilityChange(hasData ? 'visible' : 'hidden');
    }, [hasData, onVisibilityChange]);

    const content = React.useMemo(() => {
        const webText = productInfo?.WebText;
        if (!webText) {
            return null;
        }

        return <InnerHTML html={webText} />;
    }, [productInfo]);

    return props.renderView({
        ...props,
        Container: {
            moduleProps: props,
            className: classnames('hei-product-info-content', config.className)
        },
        content
    });
};

export default ProductInfoContent;
